import { Injectable } from '@angular/core';
import { Response } from '@angular/http';
import { HttpService } from '../shared/http.service';
//import { Observable } from 'rxjs/Observable';
import { Observable } from 'rxjs/Rx';
import { AppSettings } from '../shared/app-settings'
import { IMatana } from "./matana";
import { IMatanotUserDetails } from "./user-details";
import { IRishumMatana } from "./rishum-matana";
import { IEndRishumMatana } from "./end-rishum-matana/end-rishum-matana";
import { IEzorChaluka } from "./ezor-chaluka";
import { IChaluka } from "./chaluka/chaluka";
import { ConfigService } from 'app/shared/config.service';

@Injectable()
export class MatanotService {

    private apiUrl : string  = "";

    constructor(private _http: HttpService ,private _configService: ConfigService) 
    {
        this.apiUrl = _configService.getConfigPropertyByKey("apiUrl");
    }

    getMatanot(): Observable<IMatana[]> {
        let url:string = `${this.apiUrl}/api/Matana/GetMatanot`
        return this._http.get(url)
            .map((response: Response) => <IMatana[]>response.json())
            .catch(this.handleError);
    }

    getUserMatanot(): Observable<IMatanotUserDetails> {
        debugger;
        let url : string = `${this.apiUrl}/api/Matana/GetUserMatanot`
        return this._http.get(url)
            .map((response: Response) => <IMatanotUserDetails>response.json())
            .catch(this.handleError);
    }

    saveRishumMatana(rishum: IRishumMatana): Observable<IRishumMatana> {
        let url: string = `${this.apiUrl}/api/Matana/SaveRishumMatana`
        return this._http.post(url, JSON.stringify(rishum))
            .map(res => res.json())
            .catch(this.handleError)
    }

    getEndRishumMatana(): Observable<IEndRishumMatana> {
        let url : string = `${this.apiUrl}/api/Matana/GetEndRishumMatana`
        return this._http.get(url)
            .map((response: Response) => <IEndRishumMatana>response.json())
            .catch(this.handleError);
    }

    getMatanaEzorChaluka(): Observable<IEzorChaluka[]> {
        let url : string = `${this.apiUrl}/api/Matana/GetMatanaEzorChaluka`
        return this._http.get(url)
            .map((response: Response) => <IEzorChaluka[]>response.json())
            .catch(this.handleError);
    }

    getChalukatMatanot(): Observable<IChaluka[]> {
        let url: string = `${this.apiUrl}/api/Matana/GetChlukatMatanot`
        return this._http.get(url)
            .map((response: Response) => <IChaluka[]>response.json())
            .catch(this.handleError);
    }

    saveChalukaApproved(ms_zehut: number, signature: string): Observable<any> {
        let url : string = `${this.apiUrl}/api/Matana/SaveChalukaApproved`
        return this._http.post(url, JSON.stringify({ ms_zehut: ms_zehut, signature: signature }))
            .map(res => res.json())
            .catch(this.handleError)
    }

    private handleError(error: Response | any) {
        // in a real world app, we may send the server to some remote logging infrastructure
        // instead of just logging it to the console
        let errMsg: string;
        if (error instanceof Response) {
            const body = error.json() || '';
            const err = body.error || JSON.stringify(body);

            errMsg = `${error.status} - ${error.statusText || ''} ${err}`;

        } else {
            errMsg = error.message ? error.message : error.toString();
        }
        //console.error(errMsg);
      return Observable.throwError(errMsg);
    }
}
